import { memo } from "react";
import { FieldTypeEditorProps } from "../types";

export const CheckboxFieldTypeSpecificProps = memo(
  (_props: FieldTypeEditorProps) => null,
);
